import { Injector, Pipe, PipeTransform } from '@angular/core';
import { locales } from 'src/app/config/i18n-config';
import { LocaleDataService } from '../angular-common/locale-data.service';

@Pipe({
  name: 'languageShortLabel'
})
export class LanguageShortLabel implements PipeTransform {

  constructor(protected _injector: Injector){}

  transform(value: string): string {
    //.filter(el=>el.id==this._injector.get(LocaleDataService).locale)
    return locales.filter(el=>{
      const a =  (el.id as string).split('_').join('-').toLocaleLowerCase()
      const b =   this._injector.get(LocaleDataService).locale.toLocaleLowerCase()
      return a==b
    })[0].shortLabel //locales.toString()
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}